export const savingsOverviewNb = {
    savingsOverview: {
        savingsDistributionSummary: {
            ariaLabel: 'Oversikt over sparing',
            loadingLabel: 'Laster oversikt over sparing',
            totalLabel: 'Total sparing',
            savingsLabel: 'Sparekonto',
            fundsLabel: 'Fond',
            sharesLabel: 'Aksjer',
            errorHeading: 'Kunne ikke hente oversikt over sparing',
            errorText: 'Vi klarte ikke å hente sparebeløpet ditt. Prøv igjen senere.',
        },
        showing: 'Viser {} av {}',
        total: 'Totalt: {}',
    },
    savingsAccounts: {
        accountTrackingLabel: 'Gå til sparekonto',
        heading: 'Sparekonto',
        listLabel: 'Sparekontoer',
        loadingLabel: 'Laster sparekontoer',
        fetchError: 'Kunne ikke hente sparekontoer. Prøv igjen senere.',
        emptyStateTitle: 'Sparing på sparekonto',
        emptyStateDescription: 'Spar trygt på konto og ha pengene tilgjengelig når du trenger dem. Opprett en sparekonto på få minutter.',
        emptyStateCreateSavingsAccount: 'Opprett sparekonto',
        interestsLoadingLabel: 'Laster opptjente renter',
        interestsEarnedFirstPart: 'Visste du at du har opptjent ',
        interestsEarnedLastPart: ' i renter på kontoer? Rentene utbetales på slutten av året.',
    },
    savingsFunds: {
        fundTrackingLabel: 'Gå til fond: {}',
        heading: 'Fond',
        loadingLabel: 'Laster fond',
        fetchError: 'Kunne ikke hente fond. Prøv igjen senere.',
        seeAllFunds: 'Gå til fondsside',
        hasPendingOrder: 'Ordre på vei',
        noFunds: {
            title: 'Sparing i fond',
            descriptionLineOne: 'Har du et sparemål som ligger litt frem i tid?',
            descriptionLineTwo: 'Fond kan hjelpe sparepengene dine til å vokse over tid.',
            startFundSaving: 'Lær mer om fondssparing',
            fundGuide: 'Finn fond som passer for deg',
            savingsGrowthCalculator: 'Se hva sparingen din kan vokse til',
        },
    },
    authorizedSavingsAccounts: {
        accountTrackingLabel: 'Gå til sparekonto',
        heading: 'Sparekontoer du har tilgang til',
        loadingLabel: 'Laster delte sparekontoer',
        fetchError: 'Kunne ikke hente delte sparekontoer. Prøv igjen senere.',
    },
    authorizedFundAccounts: {
        accountTrackingLabel: 'Gå til fondskonto',
        heading: 'Fondskontoer du har tilgang til',
        loadingLabel: 'Laster aksjesparekontoer du har tilgang til',
        fetchError: 'Kunne ikke hente aksjesparekontoer du har tilgang til. Prøv igjen senere.',
    },
    savingsAgreementsAccounts: {
        seeExistingAgreements: 'Se spareavtaler sparekonto',
        startNewAgreement: 'Start spareavtale sparekonto',
        title: 'Fast overføring til konto',
        monthlyAmount: '{} per måned',
        nextPaymentDate: 'Neste trekk den {}',
        startSavingTitle: 'Fast sparing til sparekonto',
        startSavingDescription: 'Sett av et fast beløp hver måned, så slipper du å huske det selv.',
        loadingLabel: 'Laster faste overføringer til konto',
        fetchError: 'Kunne ikke hente faste overføringer til konto. Prøv igjen senere.',
    },
    savingsAgreementsFunds: {
        seeExistingAgreements: 'Se spareavtaler i fond',
        startNewAgreement: 'Start spareavtale i fond',
        title: 'Spareavtale i fond',
        monthlyAmount: '{} per måned',
        nextPaymentDate: 'Neste trekk den {}',
        startSavingTitle: 'Spareavtale i fond',
        startSavingDescription: 'Sett av et fast beløp hver måned, så slipper du å huske det selv.',
        loadingLabel: 'Laster spareavtaler i fond',
        fetchError: 'Kunne ikke hente spareavtaler i fond. Prøv igjen senere.',
    },
    savingsAgreementsMicrosaving: {
        seeExistingAgreements: 'Se mikrosparavtaler',
        startNewAgreement: 'Start mikrosparing',
        title: 'Mikrosparing',
        oneAgreement: 'Du har {} mikrosparavtale',
        multipleAgreements: 'Du har {} mikrosparavtaler',
        description: 'Se dine avtaler',
        loadingLabel: 'Laster mikrosparavtaler',
        fetchError: 'Kunne ikke hente mikrosparavtaler. Prøv igjen senere.',
        startTitle: 'Mikrosparing',
        startDescription: 'Spar automatisk hver gang du bruker kortet. Kom i gang med mikrosparing.',
    },
    savingsEncouragement: {
        loadingLabel: 'Laster sparetips',
        texts: {
            NO_SAVINGS_PRODUCTS: 'Kom i gang med sparing! Finn en spareform som passer dine behov.',
            ACCOUNT_NO_FUNDS: 'Skal du spare over lengre tid? Se om fond kan passe for deler av sparingen din.',
            ACCOUNT_FUNDS_NO_AGREEMENTS: 'Gjør sparingen enklere med en spareavtale. Velg et beløp som settes av automatisk hver måned.',
            ACCOUNT_FUNDS_AGREEMENTS: 'Bra jobbet - du sparer jevnt og trutt! Selv et lite beløp kan vokse seg stort over tid.',
        },
        actions: {
            FIND_SAVINGS_PRODUCT: 'Finn en spareform',
            VIEW_FUNDS: 'Se sparing i fond',
            START_SAVING_AGREEMENT: 'Start fast sparing',
            INCREASE_SAVINGS_AMOUNT: 'Øk sparebeløp',
        },
    },
};
//# sourceMappingURL=data:application/json;base64,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